/* eslint-disable complexity */
import { SECT_APPLICANT, SECT_FILER, SECT_ORGANISATION } from 'common/application.const';
import { SECT_TYPE } from 'common/application.const/Licence/MyApplication/aelGeneral';
import { APPLICANT_CONTACT, PERSON_CONTACT } from 'common/application.const/Licence/MyLicence/expressLetter';
import { formatDateTime } from 'utils/application.helpers';
import aslPayload from './licences/asl';
import sslPayload from './licences/ssl';
import elsPayload from './licences/els';
import aircraftPayload from './licences/aircraft';
import lpnPayload from './licences/lpn';
import aelPayload from './licences/ael';
import grsPayload from './licences/grs';
import lrsPayload from './licences/lrs';
import pmnPayload from './licences/pmn';
import scsPayload from './licences/scs';
import ssocPayload from './licences/ssoc';
import tdiPayload from './licences/tdi';
import tdcPayload from './licences/tdc';
import gerPayload from './licences/ger';
import gercbPayload from './licences/gercb';
import serPayload from './licences/ser';
import eserPayload from './licences/eser';
import cofcPayload from './licences/cofc';
import pplPayload from './licences/ppl';
import nppPayload from './licences/npp';
import fwnPayload from './licences/fwn';
import wpnPayload from './licences/wpn';
import eslPayload from './licences/esl';
import ttfPayload from './licences/ttf';
import tufPayload from './licences/tuf';
import spsPayload from './licences/sps';
import sboiPayload from './licences/sboi';
import tvroPayload from './licences/tvro';
import fdelPayload from './licences/fdel';
import tcdwclPayload from './licences/tcdwcl';
import tfPayload from './licences/tf';
import sbocPayload from './licences/sboc';
import commonPayload from './common';
import lpnApplicationPayload from './licApplication/lpn';
import grsApplicationPayload from './licApplication/grs';
import pmnApplicationPayload from './licApplication/pmn';
import sslApplicationPayload from './licApplication/ssl';
import lrsApplicationPayload from './licApplication/lrs';
import scsPayloadApplication from './licApplication/scs';
import ssocPayloadApplication from './licApplication/ssoc';
import tdiPayloadApplication from './licApplication/tdi';
import tdcPayloadApplication from './licApplication/tdc';
import gerPayloadApplication from './licApplication/ger';
import gercbPayloadApplication from './licApplication/gercb';
import serPayloadApplication from './licApplication/ser';
import eserPayloadApplication from './licApplication/eser';
import cofcPayloadApplication from './licApplication/cofc';
import pplPayloadApplication from './licApplication/ppl';
import nppPayloadApplication from './licApplication/npp';
import fwnApplicationPayload from './licApplication/fwn';
import wpnApplicationPayload from './licApplication/wpn';
import eslApplicationPayload from './licApplication/esl';
import spsApplicationPayload from './licApplication/sps';
import ttfApplicationPayload from './licApplication/ttf';
import tufApplicationPayload from './licApplication/tuf';
import sboiPayloadApplication from './licApplication/sboi';
import tvroPayloadApplication from './licApplication/tvro';
import fdelPayloadApplication from './licApplication/fdel';
import tcdwclPayloadApplication from './licApplication/tcdwcl';
import tfApplicationPayload from './licApplication/tf';
import ispApplicationPayload from './licApplication/isp';
import sbocPayloadApplication from './licApplication/sboc';

import { licenceList } from 'common/constants';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    PRINTING_PRESS_PARTICULARS,
    PRINTING_PRESS_OPERATING_ADDRESS,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyLicence/licenceOrganisation';
import { CORRESPONDENCE_DETAILS } from 'common/application.const/Licence/contactDetails';
import { findCountryByCode } from 'utils/utils';
import twiclPayloadApplication from './licApplication/twicl';
import twiclPayload from './licences/twicl';
import twcclPayloadApplication from './licApplication/twccl';
import twcclPayload from './licences/twccl';
import exbApplicationPayload from './licApplication/exb';
import exbPayload from './licences/exb';
import exbfApplicationPayload from './licApplication/exbf';
import exbfPayload from './licences/exbf';
import ispPayload from './licences/isp';
import roeLicencePayload from './licences/roe';
import acaLicencePayload from './licences/aca';
import aaLicencePayload from './licences/aa';

export const formatRetrieve = async (content: any, caseTypeID: string, action?: string, application?: string) => {
    const applicantValues = content?.LICApplication ?? {};
    const applicant = applicantValues.applicant ?? {};
    const filer = applicantValues?.filer ?? {};
    const company = applicantValues?.company ?? {};
    const general = applicantValues?.general ?? {};
    let licenceDetails = applicantValues?.licence ?? {};
    const additionalApplicantParticulars = licenceDetails.additionalApplicantParticulars ?? {};
    const additionalApplicantParticularsOnlyNppAndPPl = licenceDetails.additionalParticularsOfApplicantChiefEditorProprietor ?? {};
    const particularsOfApplicantChiefEditorProprietorOfficeContact =
        licenceDetails.particularsOfApplicantChiefEditorProprietorOfficeContact ?? {};
    const particularsOfChiefEditorResidentialAddressNPPPPL = licenceDetails.particularsOfChiefEditorResidentialAddress ?? {};
    const applicantContact = licenceDetails.applicantContact ?? {};
    const additionalFilerParticulars = licenceDetails.additionalFilerParticulars ?? {};
    const totalNoOfStations = applicantValues?.StationCountInfo?.TotalNoOfStations ?? {};
    const isAEL = (content?.licenceName as string).replace(/\s/g, ' ') === 'Arts Entertainment Licence';

    if (content?.licenceName === 'Film (Distribution/Exhibition) Licence') {
        licenceDetails = {
            ...licenceDetails,
            company
        };
    }

    let licenceWithBillingDetails = false;
    if (action === 'download') {
        if (!isAEL && !application?.startsWith('IMDA-IRIS-Work-LICApplication')) {
            const licenceDownload = commonPayload.getLicenceDownload(caseTypeID);
            return licenceDownload;
        } else {
            const licenceDownload = commonPayload.getApplicationDownload(caseTypeID, content?.licenceName);
            return licenceDownload;
        }
    }

    let licence = {
        id: 'express-letter',
        formID: 'express-letter',
        hasError: true,
        title: 'Licence Details',
        values: {}
    };
    const transactionType = general.transactionType.charAt(0).toUpperCase() + general.transactionType.slice(1) || '';
    const summary = await commonPayload.getSummaryDetails(licenceDetails, isAEL, content, general);

    let customExpDate = '';
    let cancellationDate = '';
    if (content.ExpirationDate) {
        customExpDate = formatDateTime(content.ExpirationDate, true);
    }
    if (!application?.startsWith('IMDA-IRIS-Work-LICApplication') && !isAEL) {
        if (content?.LICCancellation?.EffectiveCancellationDate) {
            cancellationDate = formatDateTime(content.LICCancellation.EffectiveCancellationDate || '', true);
        } else {
            const customDate = content.LICApplication.licence?.cancellationInformation?.effectiveDateOfCancellation || [];
            cancellationDate = formatDateTime(`${customDate.slice(0, 4)}-${customDate.slice(4, 6)}-${customDate.slice(6, 8)}`, true);
        }
    }
    const paymentDetails = await commonPayload.getPaymentDetails(licenceDetails, transactionType, content, customExpDate, cancellationDate);

    const billingDetails = await commonPayload.getBillingDetails(licenceDetails, transactionType, content, customExpDate, cancellationDate);

    let Address = {};

    let newDocs;
    let newPayload;
    let docsLic;

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    for (const key in licenceDetails.supportingDocuments) {
        if (licenceDetails.supportingDocuments.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.supportingDocuments[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceList.some((licence) => licence.includes(general.licenceName))) {
        Address = {
            [`${SECT_ORGANISATION}-companyPostal`]: (company?.registeredAddress?.postalCode || applicant?.address?.postalCode) ?? '',
            [`${SECT_ORGANISATION}-company-block-house`]: (company?.registeredAddress?.blockNo || applicant?.address?.blockNo) ?? '',
            [`${SECT_ORGANISATION}-company-street`]: (company?.registeredAddress?.streetName || applicant?.address?.streetName) ?? '',
            [`${SECT_ORGANISATION}-company-building`]: (company?.registeredAddress?.buildingName || applicant?.address?.buildingName) ?? '',
            [`${SECT_ORGANISATION}-company-floor`]: (company?.registeredAddress?.floor || applicant?.address?.floor) ?? '',
            [`${SECT_ORGANISATION}-company-unit`]: (company?.registeredAddress?.unit || applicant?.address?.unit) ?? '',

            [`${SECT_ORGANISATION}-address-type`]: company?.registeredAddress?.addressType ?? 'Local',
            [`${SECT_ORGANISATION}-foreign-address-line-one`]:
                (company?.registeredAddress?.AddressLine1 || company?.registeredAddress?.foreignAddress1) ?? '',
            [`${SECT_ORGANISATION}-foreign-address-line-two`]:
                (company?.registeredAddress?.AddressLine2 || company?.registeredAddress?.foreignAddress2) ?? '',
            [`${SECT_ORGANISATION}-foreign-address-line-three`]:
                (company?.registeredAddress?.addressLine3 || company?.registeredAddress?.foreignAddress3) ?? '',
            [`${SECT_ORGANISATION}-city`]: (company?.registeredAddress?.City || company?.registeredAddress?.city) ?? '',
            [`${SECT_ORGANISATION}-state`]: (company?.registeredAddress?.State || company?.registeredAddress?.state) ?? '',
            [`${SECT_ORGANISATION}-zip-code`]: (company?.registeredAddress?.ZipCode || company?.registeredAddress?.zipCode) ?? '',
            [`${SECT_ORGANISATION}-country`]: findCountryByCode(company?.registeredAddress?.country || company?.registeredAddress?.Country)
        };
    } else {
        Address = {
            [`${SECT_ORGANISATION}-companyPostal`]: (company?.address?.postalCode || applicant?.address?.postalCode) ?? '',
            [`${SECT_ORGANISATION}-company-block-house`]: (company?.address?.blockNo || applicant?.address?.blockNo) ?? '',
            [`${SECT_ORGANISATION}-company-street`]: (company?.address?.streetName || applicant?.address?.streetName) ?? '',
            [`${SECT_ORGANISATION}-company-building`]: (company?.address?.buildingName || applicant?.address?.buildingName) ?? '',
            [`${SECT_ORGANISATION}-company-floor`]: (company?.address?.floor || applicant?.address?.floor) ?? '',
            [`${SECT_ORGANISATION}-company-unit`]: (company?.address?.unit || applicant?.address?.unit) ?? '',

            [`${SECT_ORGANISATION}-address-type`]: company?.address?.addressType ?? 'Local',
            [`${SECT_ORGANISATION}-foreign-address-line-one`]: (company?.address?.AddressLine1 || company?.address?.foreignAddress1) ?? '',
            [`${SECT_ORGANISATION}-foreign-address-line-two`]: (company?.address?.AddressLine2 || company?.address?.foreignAddress2) ?? '',
            [`${SECT_ORGANISATION}-foreign-address-line-three`]:
                (company?.address?.addressLine3 || company?.address?.foreignAddress3) ?? '',
            [`${SECT_ORGANISATION}-city`]: (company?.address?.City || company?.address?.city) ?? '',
            [`${SECT_ORGANISATION}-state`]: (company?.address?.State || company?.address?.state) ?? '',
            [`${SECT_ORGANISATION}-zip-code`]: (company?.address?.ZipCode || company?.address?.zipCode) ?? '',
            [`${SECT_ORGANISATION}-country`]: findCountryByCode(company?.registeredAddress?.country || company?.registeredAddress?.Country)
        };
    }
    const billingData = commonPayload.getBillingData(licenceDetails);

    let orgTitle = '';
    if (isAEL) {
        orgTitle = 'Applicant/Filer Details';
    }
    if (application?.startsWith('IMDA-IRIS-Work-LICApplication')) {
        orgTitle = 'General Information';
    }
    if (
        application?.startsWith('IMDA-IRIS-Work-Licence-MNPP') ||
        application?.startsWith('IMDA-IRIS-Work-Licence-BCG') ||
        application?.startsWith('IMDA-IRIS-Work-Licence-TELE')
    ) {
        orgTitle = 'Licence Particulars';
    }

    const MULTI_CONTACT_LICENSES = new Set(['Film (Distribution/Exhibition) Licence']);
    const isMultiContact = MULTI_CONTACT_LICENSES.has(content?.licenceName);

    const contactPersons = Array.isArray(licenceDetails?.contactPersonParticularList) ? licenceDetails.contactPersonParticularList : [];

    let contactPersonList = [];
    if (licenceDetails && contactPersons && contactPersons.length > 0) {
        contactPersonList = contactPersons.map((value: any) => ({
            Salutation: value?.Salutation ?? '-',
            name: value?.name ?? '-',
            designation: value?.designation ?? '-',
            idType: value?.idType ?? '-',
            email: value?.email ?? '-',
            ContactNumber: value?.ContactNumber ?? '-',
            notifyViaSmsForFutureLicenceRenewal: value?.notifyViaSmsForFutureLicenceRenewal ?? '-'
        }));
    }

    const orgForm = {
        id: 'organisation',
        formID: isAEL ? 'applicant/filer-ael' : 'organisation',
        title: orgTitle === '' ? 'Licensee Details' : orgTitle,
        hasError: true,
        values: {
            [`${SECT_TYPE}-applicant-type`]:
                applicantValues?.profile?.applyAs?.toLocaleLowerCase() === 'as an applicant' ? 'Applicant' : 'Filer',
            [`${SECT_ORGANISATION}-applicant-type`]: applicantValues?.profile?.applyAs ?? '',

            ...(isMultiContact
                ? {
                      'applicant-contact-person-table-list': contactPersonList ?? [...contactPersonList]
                  }
                : {
                      [`${APPLICANT_CONTACT}-applicantParticulars`]:
                          licenceDetails?.contactPersonParticulars?.sameAsApplicantParticulars ?? '',
                      [`${APPLICANT_CONTACT}-name`]: licenceDetails?.contactPersonParticulars?.name ?? '',
                      [`${APPLICANT_CONTACT}-designation`]: licenceDetails?.contactPersonParticulars?.designation ?? '',
                      [`${APPLICANT_CONTACT}-telNumber`]: licenceDetails?.contactPersonParticulars?.officeTelNumber ?? '',
                      [`${APPLICANT_CONTACT}-mobileNo`]: licenceDetails?.contactPersonParticulars?.mobileNumber ?? '',
                      [`${APPLICANT_CONTACT}-email`]: licenceDetails?.contactPersonParticulars?.email ?? ''
                  }),

            [`${CORRESPONDENCE_DETAILS}-buildingName`]: licenceDetails?.contactPersonAddress?.address?.buildingName ?? '-',
            [`${CORRESPONDENCE_DETAILS}-postalCode`]: licenceDetails?.contactPersonAddress?.address?.postalCode ?? '-',
            [`${CORRESPONDENCE_DETAILS}-streetName`]: licenceDetails?.contactPersonAddress?.address?.streetName ?? '-',
            [`${CORRESPONDENCE_DETAILS}-blockNo`]: licenceDetails?.contactPersonAddress?.address?.blockNo ?? '-',
            [`${CORRESPONDENCE_DETAILS}-floor`]: licenceDetails?.contactPersonAddress?.address?.floor ?? '-',
            [`${CORRESPONDENCE_DETAILS}-unit`]: licenceDetails?.contactPersonAddress?.address?.unit ?? '-',

            [`${PERSON_CONTACT}-contactPersonParticulars`]: licenceDetails?.billingPersonParticulars?.sameAsContactPersonParticulars ?? '',
            [`${PERSON_CONTACT}-name`]: licenceDetails?.billingPersonParticulars?.name ?? '',
            [`${PERSON_CONTACT}-designation`]: licenceDetails?.billingPersonParticulars?.designation ?? '',
            [`${PERSON_CONTACT}-telNumber`]: licenceDetails?.billingPersonParticulars?.officeTelNumber ?? '',
            [`${PERSON_CONTACT}-mobileNo`]: licenceDetails?.billingPersonParticulars?.mobileNumber ?? '',
            [`${PERSON_CONTACT}-email`]: licenceDetails?.billingPersonParticulars?.email ?? '',

            // Company
            [`${SECT_ORGANISATION}-companyName`]: company?.companyName ?? '',
            [`${SECT_ORGANISATION}-uenNo`]: company?.uen ?? '',
            [`${SECT_ORGANISATION}-entityType`]: company?.entityType ?? '',
            [`${SECT_ORGANISATION}-officeNo`]: company?.Contact?.OfficeNo ?? '',
            ...Address,
            // Applicant
            [`${SECT_ORGANISATION}-licenceName`]: general?.licenceName ?? '',

            [`${SECT_ORGANISATION}-salutation`]: applicant?.salutation ?? '',
            [`${SECT_ORGANISATION}-name`]: applicant?.name ?? '',
            [`${SECT_ORGANISATION}-idType`]: applicant?.idType ?? '',
            [`${SECT_ORGANISATION}-idNumber`]: applicant?.idNumber ?? '',
            [`${SECT_ORGANISATION}-email`]: applicant?.email ?? '',
            [`${SECT_ORGANISATION}-contactNumber`]: applicant?.contactNumber ?? '',

            // [`${SECT_ORGANISATION}-dateOfBirth`]:
            //     additionalApplicantParticulars?.dateOfBirth || additionalApplicantParticularsOnlyNppAndPPl?.dateOfBirth || '',
            [`${SECT_ORGANISATION}-nationality`]:
                additionalApplicantParticulars?.nationality || additionalApplicantParticularsOnlyNppAndPPl?.NationalityJSON || '',
            [`${SECT_ORGANISATION}-passportNumber`]:
                additionalApplicantParticulars?.passportNumber || additionalApplicantParticularsOnlyNppAndPPl?.passportNo || '',
            [`${SECT_ORGANISATION}-designation`]:
                additionalApplicantParticulars?.designation || additionalApplicantParticularsOnlyNppAndPPl?.designation || '',
            [`${SECT_ORGANISATION}-telephoneNumber`]:
                applicantContact?.telephoneNumber || particularsOfApplicantChiefEditorProprietorOfficeContact?.officeTelNumber || '',
            [`${SECT_ORGANISATION}-mobileNumber`]:
                applicantContact?.mobileNo || particularsOfApplicantChiefEditorProprietorOfficeContact?.mobileNumber || '',

            [`${SECT_ORGANISATION}-postal`]:
                (applicant?.address?.postalCode ||
                    additionalApplicantParticulars?.applicantResidentialAddress?.postalCode ||
                    particularsOfChiefEditorResidentialAddressNPPPPL?.localAddress?.postalCode) ??
                '',
            [`${SECT_ORGANISATION}-block-house`]:
                (applicant?.address?.blockNo ||
                    additionalApplicantParticulars?.applicantResidentialAddress?.blockNo ||
                    particularsOfChiefEditorResidentialAddressNPPPPL?.localAddress?.blockNo) ??
                '',
            [`${SECT_ORGANISATION}-street`]:
                (applicant?.address?.streetName ||
                    additionalApplicantParticulars?.applicantResidentialAddress?.streetName ||
                    particularsOfChiefEditorResidentialAddressNPPPPL?.localAddress?.streetName) ??
                '',
            [`${SECT_ORGANISATION}-building`]:
                (applicant?.address?.buildingName ||
                    additionalApplicantParticulars?.applicantResidentialAddress?.buildingName ||
                    particularsOfChiefEditorResidentialAddressNPPPPL?.localAddress?.buildingName) ??
                '',
            [`${SECT_ORGANISATION}-floor`]:
                (applicant?.address?.floor ||
                    additionalApplicantParticulars?.applicantResidentialAddress?.floor ||
                    particularsOfChiefEditorResidentialAddressNPPPPL?.localAddress?.floor) ??
                '',
            [`${SECT_ORGANISATION}-unit`]:
                (applicant?.address?.unit ||
                    additionalApplicantParticulars?.applicantResidentialAddress?.unit ||
                    particularsOfChiefEditorResidentialAddressNPPPPL?.localAddress?.unit) ??
                '',

            // PPL
            [`${PRINTING_PRESS_PARTICULARS}-operating-address-is-the-same-as-acra-registered-address`]:
                licenceDetails?.printingPressParticulars?.operatingAddressIsTheSameAsAcraRegisteredAddress ?? '-',

            [`${PRINTING_PRESS_OPERATING_ADDRESS}-name-of-printing-press`]:
                licenceDetails?.printingPressParticulars?.nameOfPrintingPress ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-postal-code`]:
                licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.postalCode ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-block-house-no`]:
                licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.blockNo ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-street-name`]:
                licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.streetName ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-floor-level`]:
                licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.floor ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-unit`]:
                licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.unit ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-building-name`]:
                licenceDetails?.printingPressParticularsOperatingAddress?.operatingAddress?.buildingName ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-telephone-number`]:
                licenceDetails?.printingPressParticularsOfficeContact?.telephoneNumber ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-mobile-number`]:
                licenceDetails?.printingPressParticularsOfficeContact?.mobileNumber ?? '-',
            [`${PRINTING_PRESS_OPERATING_ADDRESS}-number-of-machines`]: licenceDetails?.printingMachineParticulars?.noOfMachines ?? '-',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined,

            // Applicant AEL
            [`${SECT_APPLICANT}-id-type`]: applicant.idType,
            [`${SECT_APPLICANT}-idno`]: applicant.idNumber,
            [`${SECT_APPLICANT}-salutaion`]: applicant.salutation,
            [`${SECT_APPLICANT}-name`]: applicant?.name ?? '',
            [`${SECT_APPLICANT}-nationality`]: 'Singapore Citizen',
            [`${SECT_APPLICANT}-uen-no`]: applicant.CompanyUEN,
            [`${SECT_APPLICANT}-company`]: applicant.CompanyName,
            [`${SECT_APPLICANT}-mobile-no`]: applicant?.contactNumber ?? '',
            [`${SECT_APPLICANT}-email`]: applicant.email,
            [`${SECT_APPLICANT}-address-type`]: 'SG',
            [`${SECT_APPLICANT}-postal`]: applicant?.address?.postalCode ?? '',
            [`${SECT_APPLICANT}-block-house`]: applicant?.address?.blockNo ?? '',
            [`${SECT_APPLICANT}-street`]: applicant?.address?.streetName ?? '',
            [`${SECT_APPLICANT}-floor`]: applicant?.address?.floor ?? '',
            [`${SECT_APPLICANT}-unit`]: applicant?.address?.unit ?? '',
            [`${SECT_APPLICANT}-building`]: applicant?.address?.buildingName ?? '',
            [`${SECT_APPLICANT}-update-via-sms`]:
                licenceDetails?.updatesViaSms?.tickIfYouPreferToReceiveStatusUpdatesOfLicenceApplicationViaSmsFromImda === 'true'
                    ? 'Yes'
                    : 'No',

            // Filer
            [`${SECT_ORGANISATION}-filerSalutation`]: filer?.salutation ?? '',
            [`${SECT_ORGANISATION}-filerName`]: filer?.name ?? '',
            [`${SECT_ORGANISATION}-filerIDType`]: filer?.idType ?? '',
            [`${SECT_ORGANISATION}-filerIDNumber`]: filer?.idNumber ?? '',
            [`${SECT_ORGANISATION}-filerEmail`]: filer?.email ?? '',
            [`${SECT_ORGANISATION}-filerContactNumber`]: filer?.contactNumber ?? '',
            [`${SECT_ORGANISATION}-filerMobileNumber`]: additionalFilerParticulars?.mobileNo ?? '',

            [`${SECT_ORGANISATION}-filerPostal`]: filer?.address?.postalCode ?? '',
            [`${SECT_ORGANISATION}-filer-block-house`]: filer?.address?.blockNo ?? '',
            [`${SECT_ORGANISATION}-filer-street`]: filer?.address?.streetName ?? '',
            [`${SECT_ORGANISATION}-filer-building`]: filer?.address?.buildingName ?? '',
            [`${SECT_ORGANISATION}-filer-floor`]: filer?.address?.floor ?? '',
            [`${SECT_ORGANISATION}-filer-unit`]: filer?.address?.unit ?? '',
            // Filer AEL
            [`${SECT_FILER}-id-type`]: filer?.idType ?? '',
            [`${SECT_FILER}-idno`]: filer?.idNumber ?? '',
            [`${SECT_FILER}-salutaion`]: filer?.salutation ?? '',
            [`${SECT_FILER}-name`]: filer?.name ?? '',
            [`${SECT_FILER}-nationality`]: 'Singapore Citizen',
            [`${SECT_FILER}-mobile-no`]: filer?.contactNumber ?? '',
            [`${SECT_FILER}-email`]: filer?.email ?? '',
            ...billingData,
            CustomerStatus: content.BusinessStatus ?? '',
            BusinessStatus: content.BusinessStatus ?? '',
            CaseRefKey: content.CaseRefKey || '',
            transactionType: transactionType || '',
            ExpirationDate: customExpDate || '',
            EffectiveCancellationDate: cancellationDate || '',
            CancellationReason:
                content?.LICCancellation?.CancellationReason || licenceDetails?.cancellationInformation?.cancellationReason || '',
            RejectionRemarks: content?.RejectionRemarks || content?.RejectionDetails?.RejectReason || ''
        }
    };

    if (isAEL) {
        licenceWithBillingDetails = false;
        licence = await aelPayload.formatAEL(licenceDetails, content);
        return [summary, orgForm, licence];
    } else {
        switch (general.licenceName) {
            case 'Radio Operator Exam':
                licenceWithBillingDetails = false;
                licence = await roeLicencePayload.formatROE(licenceDetails, caseTypeID, application);
                break;

            case 'Accreditation of Certification Authority':
                licenceWithBillingDetails = false;
                licence = await acaLicencePayload.formatACA(licenceDetails, caseTypeID, application);
                break;

            case 'Registration of Accounting Authority':
                licenceWithBillingDetails = false;
                licence = await aaLicencePayload.formatAA(licenceDetails, caseTypeID, application);
                break;

            case 'Express Letter Services Class Licence':
                licenceWithBillingDetails = false;
                licence = await elsPayload.formatELS(licenceDetails, caseTypeID);
                break;

            case 'Aircraft Station Licence':
                licenceWithBillingDetails = true;
                licence = await aircraftPayload.formatAircraft(licenceDetails, caseTypeID, application, transactionType);
                break;

            case 'Localised Private Network (Multi-Channel Radiocom Networks and Systems)':
                licenceWithBillingDetails = false;
                licence = await lpnPayload.formatLPNMultiChannel(licenceDetails);
                break;

            case 'Amateur Station Licence':
                licenceWithBillingDetails = true;
                licence = await aslPayload.formatASL(licenceDetails, caseTypeID, application, transactionType);
                break;

            case 'Ship Station Licence':
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await sslApplicationPayload.formatSSLApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await sslPayload.formatSSL(licenceDetails, caseTypeID, application);
                }
                break;

            case 'Localised Private Network Licence':
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await lpnApplicationPayload.formatLPNApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await lpnPayload.formatLPN(licenceDetails, caseTypeID, application);
                }
                break;

            case 'General Radio-com Station Licence':
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await grsApplicationPayload.formatGRSApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await grsPayload.formatGRS(licenceDetails, caseTypeID, application);
                }
                break;

            case 'Localised Radio-Communication Station Licence':
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await lrsApplicationPayload.formatLRSApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await lrsPayload.formatLRS(licenceDetails, caseTypeID, application);
                }

                break;

            case 'Public Mobile Network Licence':
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await pmnApplicationPayload.formatPMNApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await pmnPayload.formatPMN(licenceDetails, caseTypeID, application);
                }
                break;

            case 'Satellite Communication Station Licence':
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await scsPayloadApplication.formatSCSApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await scsPayload.formatSCS(licenceDetails, caseTypeID, application);
                }
                break;

            case `Ship Station Operator’s Certificate of Competency`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await ssocPayloadApplication.formatSSOCApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await ssocPayload.formatSSOC(licenceDetails, caseTypeID, application);
                }
                break;

            case `Telecommunication Dealer’s (Individual) Licence`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await tdiPayloadApplication.formatTDIApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await tdiPayload.formatTDI(licenceDetails, caseTypeID, application);
                }
                break;

            case `Telecommunication Dealer’s (Class) Licence`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await tdcPayloadApplication.formatTDCApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await tdcPayload.formatTDC(licenceDetails, caseTypeID, application);
                }
                break;

            case `General Equipment Registration (GER)`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await gerPayloadApplication.formatGERApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await gerPayload.formatGER(licenceDetails, caseTypeID, application);
                }
                break;

            case `General Equipment Registration by Certification Bodies (GER-CB)`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await gercbPayloadApplication.formatGERCBApplication(
                        licenceDetails,
                        caseTypeID,
                        application,
                        transactionType
                    );
                } else {
                    licence = await gercbPayload.formatGERCB(licenceDetails, caseTypeID, application);
                }
                break;

            case `Simplified Equipment Registration (SER)`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await serPayloadApplication.formatSERApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await serPayload.formatSER(licenceDetails, caseTypeID, application);
                }
                break;

            case `Enhanced Simplified Equipment Registration (ESER)`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await eserPayloadApplication.formatESERApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await eserPayload.formatESER(licenceDetails, caseTypeID, application);
                }
                break;

            case `Confirmation of Conformity (COFC)`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await cofcPayloadApplication.formatCOFCApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await cofcPayload.formatCOFC(licenceDetails, caseTypeID, application);
                }
                break;

            case `Printing Press Licence`:
                licenceWithBillingDetails = false;
                if (application?.startsWith('IMDA-IRIS-Work-LICApplication')) {
                    licence = await pplPayloadApplication.formatPPLApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await pplPayload.formatPPL(content, caseTypeID, application);
                }
                break;

            case `Newspaper Permit`:
                licenceWithBillingDetails = false;
                if (application?.startsWith('IMDA-IRIS-Work-LICApplication')) {
                    licence = await nppPayloadApplication.formatNPPApplication(
                        licenceDetails,
                        caseTypeID,
                        application,
                        transactionType,
                        general?.licenceName
                    );
                } else {
                    licence = await nppPayload.formatNPP(licenceDetails, caseTypeID, application);
                }
                break;

            case `Fixed Wireless Network Licence`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await fwnApplicationPayload.formatFWNApplication(
                        licenceDetails,
                        caseTypeID,
                        application,
                        totalNoOfStations,
                        transactionType
                    );
                } else {
                    licence = await fwnPayload.formatFWN(licenceDetails, caseTypeID, application);
                }
                break;

            case `Wide-Area Private Network Licence`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await wpnApplicationPayload.formatWPNApplication(
                        licenceDetails,
                        caseTypeID,
                        application,
                        totalNoOfStations,
                        transactionType
                    );
                } else {
                    licence = await wpnPayload.formatWPN(licenceDetails, caseTypeID, application, totalNoOfStations, transactionType);
                }
                break;

            case `Experimental Station Licence`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await eslApplicationPayload.formatESLApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await eslPayload.formatESL(licenceDetails, caseTypeID, application);
                }
                break;

            case `Special Purpose Station Licence`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await spsApplicationPayload.formatSPSApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await spsPayload.formatSPS(licenceDetails, caseTypeID, application);
                }
                break;

            case `Technical Trial (with use of Frequency)`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await ttfApplicationPayload.formatTTFApplication(
                        licenceDetails,
                        caseTypeID,
                        application,
                        totalNoOfStations,
                        transactionType
                    );
                } else {
                    licence = await ttfPayload.formatTTF(licenceDetails, caseTypeID, application);
                }
                break;

            case `Temporary Use of Radio Frequency`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await tufApplicationPayload.formatTUFApplication(
                        licenceDetails,
                        caseTypeID,
                        application,
                        totalNoOfStations,
                        transactionType
                    );
                } else {
                    licence = await tufPayload.formatTUF(licenceDetails, caseTypeID, application);
                }
                break;

            case `Services-Based Operations (Individual) Licence`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await sboiPayloadApplication.formatSBOIApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await sboiPayload.formatSBOI(licenceDetails, caseTypeID, application);
                }
                break;

            case `TV Receive-Only System Licence`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await tvroPayloadApplication.formatTVROApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await tvroPayload.formatTVRO(licenceDetails, caseTypeID, application);
                }
                break;

            case `Film (Distribution/Exhibition) Licence`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication-BCG') {
                    licence = await fdelPayloadApplication.formatFDELApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await fdelPayload.formatFDEL(licenceDetails, caseTypeID, application);
                }
                break;

            case `Telecommunication Cable Detection Worker Licence`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication-TELE') {
                    licence = await tcdwclPayloadApplication.formatTCDWCLApplication(
                        licenceDetails,
                        caseTypeID,
                        application,
                        transactionType
                    );
                } else {
                    licence = await tcdwclPayload.formatTCDWCL(licenceDetails, caseTypeID, application);
                }
                break;

            case `Telecommunication Wiring Installer Class Licence`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication-TELE') {
                    licence = await twiclPayloadApplication.formatTWICLApplication(
                        licenceDetails,
                        caseTypeID,
                        application,
                        transactionType
                    );
                } else {
                    licence = await twiclPayload.formatTWICL(licenceDetails, caseTypeID, application);
                }
                break;

            case `Telecommunication Wiring Contractor Class Licence`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication-TELE') {
                    licence = await twcclPayloadApplication.formatTWCCLApplication(
                        licenceDetails,
                        caseTypeID,
                        application,
                        transactionType
                    );
                } else {
                    licence = await twcclPayload.formatTWCCL(licenceDetails, caseTypeID, application);
                }
                break;

            case `Exhibition of Telecommunication Equipment (without Frequency)`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await exbApplicationPayload.formatEXBApplication(
                        licenceDetails,
                        caseTypeID,
                        application,
                        totalNoOfStations,
                        transactionType
                    );
                } else {
                    licence = await exbPayload.formatEXB(licenceDetails, caseTypeID, application);
                }
                break;

            case `Technical Trial (without use of Frequency)`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await tfApplicationPayload.formatTFApplication(licenceDetails, caseTypeID, application, transactionType);
                } else {
                    licence = await tfPayload.formatTF(licenceDetails, caseTypeID, application);
                }
                break;

            case `Exhibition of Telecommunication Equipment (with Frequency)`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await exbfApplicationPayload.formatEXBFApplication(
                        licenceDetails,
                        caseTypeID,
                        application,
                        totalNoOfStations,
                        transactionType
                    );
                } else {
                    licence = await exbfPayload.formatEXBF(licenceDetails, caseTypeID, application);
                }
                break;

            case `Registration for Internet Access Service Providers And Resellers Class Licence`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication-BCG') {
                    licence = await ispApplicationPayload.formatISPApplication(licenceDetails, caseTypeID, application);
                } else {
                    licence = await ispPayload.formatISP(licenceDetails, caseTypeID, application);
                }
                break;

            case `Services-Based Operations (Class) Licence`:
                licenceWithBillingDetails = true;
                if (application === 'IMDA-IRIS-Work-LICApplication') {
                    licence = await sbocPayloadApplication.formatSBOCApplication(
                        licenceDetails,
                        caseTypeID,
                        application,
                        transactionType
                    );
                } else {
                    licence = await sbocPayload.formatSBOC(licenceDetails, caseTypeID, application);
                }
                break;

            default:
            // Handle other cases or set a default value for 'licence' here
        }

        if (application?.startsWith('IMDA-IRIS-Work-LICApplication') && !licenceWithBillingDetails) {
            // Append Services tab last only for SBOC application flows when applicable
            if (general.licenceName === 'Services-Based Operations (Class) Licence') {
                const servicesTab = await sbocPayloadApplication.formatSBOCServices(licenceDetails);
                return [summary, orgForm, licence, servicesTab];
            }
            return [summary, orgForm, licence];
        } else if (application?.startsWith('IMDA-IRIS-Work-LICApplication') && licenceWithBillingDetails) {
            if (general.licenceName === 'Services-Based Operations (Class) Licence') {
                const servicesTab = await sbocPayloadApplication.formatSBOCServices(licenceDetails);
                return [summary, orgForm, billingDetails, licence, servicesTab];
            }
            return [summary, orgForm, billingDetails, licence];
        } else if (application?.startsWith('IMDA-IRIS-Work-Licence') && !licenceWithBillingDetails) {
            return [summary, orgForm, licence];
        } else {
            if (general.licenceName === 'Services-Based Operations (Class) Licence') {
                const servicesTab = await sbocPayload.formatSBOCServices(licenceDetails);
                return [summary, orgForm, paymentDetails, licence, servicesTab];
            }
            return [summary, orgForm, paymentDetails, licence];
        }
    }
};

const licencePayload = {
    formatRetrieve
};

export default licencePayload;
